import { render, staticRenderFns } from "./YwArtificialPatrolTaskDetailModal.vue?vue&type=template&id=7f05e1f0&"
import script from "./YwArtificialPatrolTaskDetailModal.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolTaskDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports